import { Close } from "../../svgs/Close"
import { DialogContent, DialogTitle, IconButton } from "@mui/material"
import { useTranslations } from "next-intl"
import { Routes } from "../../data/routes"

const ModalContent = ({ onClose }) => {
  const t = useTranslations("index.imprint")
  return (
    <>
      <DialogTitle>{t("title")}</DialogTitle>
      <IconButton
        style={{
          position: "absolute",
          right: "0",
          top: "0",
        }}
        onClick={() => onClose()}
      >
        <Close width={16} height={16} fill={"rgba(38, 90, 104, 1)"} type={"outlined"} />
      </IconButton>
      <DialogContent>
        <h4>{t("companyHeading")}</h4>
        <p>Skinuvita GmbH</p>
        <p>c/o Clockwise Bremen </p>
        <p>Martinistraße 62-66 </p>
        <p style={{ marginTop: "0" }}>28195 Bremen</p>
        <p>{t("company.courtAndRegister")}</p>
        <p style={{ marginTop: "0" }}>{t("company.vatId")}</p>
        <p style={{ marginTop: "0" }}>{t("company.managingDirectors")}</p>
        <h4>{t("contactHeading")}:</h4>
        <p>E-Mail: info@skinuvita.de</p>
        <h4>{t("dataProtectionHeading")}:</h4>
        <p>
          heyData GmbH
          <br />
          Schützenstraße 5<br />
          10117 Berlin
          <br />
          <a href="https://www.heydata.eu">www.heydata.eu</a>
          <br />
          <a type={"email"} href="mailto:datenschutz@heydata.eu">
            datenschutz@heydata.eu
          </a>
          <br />
        </p>
        <h4>{t("disclaimerHeading")}</h4>
        <h4
          style={{
            textDecoration: "underline",
            fontSize: "20px",
            color: "rgba(27, 200, 204, 1)",
          }}
        >
          {t("liabilityForContentTitle")}{" "}
        </h4>
        {t("liabilityForContent")}
        <h4
          style={{
            textDecoration: "underline",
            fontSize: "20px",
            color: "rgba(27, 200, 204, 1)",
          }}
        >
          {t("liabilityForExternalLinksTitle")}{" "}
        </h4>
        {t("liabilityForExternalLinks")}
        <h4
          style={{
            textDecoration: "underline",
            fontSize: "20px",
            color: "rgba(27, 200, 204, 1)",
          }}
        >
          {t("copyrightTitle")}{" "}
        </h4>
        {t("copyright")}(
        <a href={"http://www.gesetze-im-internet.de/bundesrecht/urhg/gesamt.pdf"}>{t("links.urhgReference")} </a>
        ).{t("copyright1")} (
        <a style={{ color: "" }} href={Routes.home}>
          {t("links.urhgReference")}{" "}
        </a>
        ). {t("copyright2")} <a href={"https://jurarat.de/muster-impressum"}>{t("title")}</a>
        {t("copyright22")}
        <h4
          style={{
            textDecoration: "underline",
            fontSize: "20px",
            color: "rgba(27, 200, 204, 1)",
          }}
        >
          {t("webAnalysisTitle")}{" "}
        </h4>
        {t.raw("webAnalysis")?.map((item, index) => (
          <p key={index}>{item}</p>
        ))}
      </DialogContent>
    </>
  )
}

export default ModalContent
